<div class="frame-in">
    <div id="game-holder" style="margin: 0; padding: 0"></div>
</div>
